import { render, staticRenderFns } from "./groupsIntro.vue?vue&type=template&id=739211ed"
import script from "./groupsIntro.vue?vue&type=script&lang=js"
export * from "./groupsIntro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports